<template>
  <div class="eprights-cont">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'CaseIndex',
};
</script>

<style scoped>
.eprights-cont {
  /* display: flex; */
}
</style>
